import { createApi } from '@reduxjs/toolkit/query/react';
import { customBaseQuery } from './baseQuery';

export const authCompanyApi = createApi({
  baseQuery: customBaseQuery,
  reducerPath: 'authCompanyApi',
  tagTypes: ['AuthCompany'],
  endpoints: (builder) => ({
    oAuth: builder.mutation({
      query: (params) => ({
        url: '/oauth/token',
        method: 'POST',
        body: params
      })
    }),
    sendEmail: builder.mutation({
      query: (params) => ({
        url: '/company_user/reset_password',
        method: 'GET',
        params: params
      })
    }),
    resetPassword: builder.mutation({
      query: (payload) => ({
        url: '/company_user/reset_password',
        method: 'PUT',
        params: payload.params,
        body: payload.body
      })
    }),
    getCompanyUser: builder.query({
      query: () => ({
        url: '/company_user',
        method: 'GET'
      })
    }),
    getCompanyInfo: builder.query({
      query: () => ({
        url: '/companies',
        method: 'GET',
      })
    }),
    updateStatusNotification: builder.mutation({
      query: (lastNotificationId) => ({
        url: '/company_users/update_status_notification',
        method: 'POST',
        body: { last_notification_id: lastNotificationId },
      })
    }),
    updateAllStatusNotification: builder.mutation({
      query: (lastNotificationId) => ({
        url: '/company_users/update_all_status_notification',
        method: 'POST',
        body: { last_notification_id: lastNotificationId },
      })
    }),
  })
});

export const {
  usePrefetch,
  useOAuthMutation,
  useSendEmailMutation,
  useResetPasswordMutation,
  useGetCompanyUserQuery,
  useGetCompanyInfoQuery,
  useLazyGetCompanyUserQuery,
  useUpdateStatusNotificationMutation,
  useUpdateAllStatusNotificationMutation,
} = authCompanyApi;